export class UpdateLayoutAction {
    constructor(parameters) {
        this.name = 'UpdateLayout';
        this.isDeviceAction = true;
        this.data = {};
        this.data.layoutData = parameters;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVXBkYXRlTGF5b3V0QWN0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi9tb2RlbHMvYWN0aW9ucy9VcGRhdGVMYXlvdXRBY3Rpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT0EsTUFBTSxPQUFPLGtCQUFrQjtJQUs3QixZQUFZLFVBQXVDO1FBSm5DLFNBQUksR0FBRyxjQUFjLENBQUM7UUFDdEIsbUJBQWMsR0FBRyxJQUFJLENBQUM7UUFDL0IsU0FBSSxHQUFnQyxFQUFFLENBQUM7UUFHNUMsSUFBSSxDQUFDLElBQUksQ0FBQyxVQUFVLEdBQUcsVUFBVSxDQUFDO0lBQ3BDLENBQUM7Q0FDRiJ9